module.exports = __webpack_public_path__ + "static/img/system_3.b8eb2b58.svg";